/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faImage } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux"; // Import useDispatch hook
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addDashboardToCampaign,
  selectCampaigns,
  fetchCampaigns,
} from "./campaignSlice";
import "../features/AdbotDashboardForm.css";
import { SketchPicker } from "react-color";

function AdbotDashboardForm({
  onHandleClose,
  campaignName,
  campaignDomain,
  campaignId,
  campaignFallBackUrl,
  campaignStatus,
  campaignLeadQuestionNumber,
  campaignLeadFields,

}) {
  // State variables for header section
  const [activeTab, setActiveTab] = useState("header");
  const [headerBackgroundColor, setHeaderBackgroundColor] = useState("");
  const [logoDimensions, setLogoDimensions] = useState({
    width: "",
    height: "",
  });
  const [headerHeight, setHeaderHeight] = useState({ width: "", height: "" });
  const [logoImage, setLogoImage] = useState(null);
  const [textOne, setTextOne] = useState("");
  const [fontSizeOne, setFontSizeOne] = useState("");
  const [fontColorOne, setFontColorOne] = useState("");
  const [textTwo, setTextTwo] = useState("");
  const [fontSizeTwo, setFontSizeTwo] = useState("");
  const [fontColorTwo, setFontColorTwo] = useState("");
  const [headingFontFamily, setHeadingFontFamily] = useState("");
  const [subHeadingFontFamily, setSubHeadingFontFamily] = useState("");

  // State variables for body section
  const [bodyBackgroundType, setBodyBackgroundType] = useState("color");
  const [bodyBackgroundColor, setBodyBackgroundColor] = useState("#ffffff");
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [urlField, setUrlField] = useState("");
  const [inputTexts, setInputTexts] = useState(["", ""]);
  const [inputCount, setInputCount] = useState(1);
  const [textarea, setTextArea] = useState("");
  const [messagefontColorOne, setMessagefontColorOne] = useState("");
  const [messagefontColorTwo, setMessagefontColorTwo] = useState("");
  const [messagefontSize, setMessageFontSize] = useState("");
  const [initialfontColorOne, setInitialfontColorOne] = useState("");
  const [initialfontColorTwo, setInitialfontColorTwo] = useState("");
  const [initialfontSize, setInitialFontSize] = useState("");
  const [questionfontColorOne, setQuestionfontColorOne] = useState("");
  const [questionfontColorTwo, setQuestionfontColorTwo] = useState("");
  const [questionfontSize, setQuestionFontSize] = useState("");
  const [answerfontColorOne, setAnswerfontColorOne] = useState("");
  const [answerfontColorTwo, setAnswerfontColorTwo] = useState("");
  const [answerfontSize, setAnswerFontSize] = useState("");
  const [introFontFamily, setIntroFontFamily] = useState("");
  const [initialQuestionFontFamily, setInitialQuestionFontFamily] =
    useState("");
  const [questionFontFamily, setQuestionFontFamily] = useState("");
  const [answerFontFamily, setAnswerFontFamily] = useState("");

  // State variables for footer section
  const campaigns = useSelector(selectCampaigns);
  const selectedCampaign = campaigns.find(
    (campaign) => campaign.id === campaignId
  );
  const [sendfontColorOne, setSendfontColorOne] = useState("");
  const [sendfontColorTwo, setSendfontColorTwo] = useState("");
  const [sendfontSize, setsendFontSize] = useState("");
  // COMMON
  const inputRef = useRef(null);
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const dispatch = useDispatch(); // Initialize useDispatch hook

  const handleInputChanged = (e, index) => {
    const { value } = e.target;
    setInputTexts((prevTexts) => {
      const updatedTexts = [...prevTexts];
      updatedTexts[index] = value;
      return updatedTexts;
    });
  };

  const incrementInputCount = () => {
    if (inputCount < 3) {
      // Limiting to 3 pairs
      setInputTexts((prevTexts) => [...prevTexts, "", ""]); // Add empty pair
      setInputCount((prevCount) => prevCount + 1); // Increment count
    }
  };

  const decrementInputCount = () => {
    if (inputCount > 1) {
      // At least one pair should remain
      setInputCount((prevCount) => prevCount - 1); // Decrement count
      setInputTexts((prevTexts) => prevTexts.slice(0, -2)); // Remove the last pair
    }
  };

  // Function to handle background type change
  const handleBackgroundTypeChange = (e) => {
    setBodyBackgroundType(e.target.value);
  };

  // Function to handle background color change
  const handleColorChange = (color, property) => {
    switch (property) {
      case "headerBackground":
        setHeaderBackgroundColor(color.hex);
        break;
      case "fontColorOne":
        setFontColorOne(color.hex);
        break;
      case "fontColorTwo":
        setFontColorTwo(color.hex);
        break;
      case "messageFontColorOne":
        setMessagefontColorOne(color.hex);
        break;
      case "messageFontColorTwo":
        setMessagefontColorTwo(color.hex);
        break;
      case "bodyBackgroundColor":
        setBodyBackgroundColor(color.hex);
        break;
      case "initialFontColorOne":
        setInitialfontColorOne(color.hex);
        break;
      case "initialFontColorTwo":
        setInitialfontColorTwo(color.hex);
        break;
      case "questionFontColorOne":
        setQuestionfontColorOne(color.hex);
        break;
      case "questionFontColorTwo":
        setQuestionfontColorTwo(color.hex);
        break;
      case "answerFontColorOne":
        setAnswerfontColorOne(color.hex);
        break;
      case "answerFontColorTwo":
        setAnswerfontColorTwo(color.hex);
        break;
      case "sendFontColorOne":
        setSendfontColorOne(color.hex);
        break;
      case "sendFontColorTwo":
        setSendfontColorTwo(color.hex);
        break;
      default:
        break;
    }
  };

  // Function to handle image drop
  const handleBackImageDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      handleImage(file);
    }
  };
  // Function to handle image select
  const handleBackImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleBackImage(file);
    }
  };
  // Function to handle image
  const handleBackImage = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      setBackgroundImage(reader.result);
    };
    reader.readAsDataURL(file);
  };
  // Function to handle tab click
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // // Function to handle input change for logo dimensions
  // const handleInputChange = (e, dimension) => {
  //   const { value } = e.target;
  //   setLogoDimensions((prevDimensions) => ({
  //     ...prevDimensions,
  //     [dimension]: parseInt(value),
  //   }));
  // };

  // // Function to handle input change for header height
  // const handleInputChangee = (e, dimension) => {
  //   const { value } = e.target;
  //   setHeaderHeight((prevDimensions) => ({
  //     ...prevDimensions,
  //     [dimension]: parseInt(value),
  //   }));
  // };

  // Function to handle image drop
  const handleImageDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      handleImage(file);
    }
  };

  // Function to handle image remove
  const handleImageRemove = () => {
    setLogoImage(null);
    setBackgroundImage(null);
  };

  // Function to handle image select
  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleImage(file);
    }
  };

  // Function to handle image
  const handleImage = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      setLogoImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    if (selectedCampaign && selectedCampaign.header) {
      console.log("Selected Campaign:", selectedCampaign);
      setHeaderBackgroundColor(selectedCampaign.header.backgroundColor || "");
      setLogoImage(selectedCampaign.header.logo?.imageUrl || "");
      setLogoDimensions({
        width: selectedCampaign.header.logo?.width || "",
        height: selectedCampaign.header.logo?.height || "",
      });
      setTextOne(selectedCampaign.header.heading?.text || "");
      setHeadingFontFamily(selectedCampaign.header.heading?.fontFamily || "");
      setFontSizeOne(selectedCampaign.header.heading?.fontSize || "");
      setFontColorOne(selectedCampaign.header.heading?.fontColor || "");
      setTextTwo(selectedCampaign.header.subHeading?.text || "");
      setFontSizeTwo(selectedCampaign.header.subHeading?.fontSize || "");
      setFontColorTwo(selectedCampaign.header.subHeading?.fontColor || "");
      setSubHeadingFontFamily(
        selectedCampaign.header.subHeading?.fontFamily || ""
      );

      // Check for body properties
      if (selectedCampaign.body) {
        setBodyBackgroundType(
          selectedCampaign.body.background?.type || "color"
        );
        setBodyBackgroundColor(
          selectedCampaign.body.background?.color || "#ffffff"
        );
        setBackgroundImage(selectedCampaign.body.background?.imageUrl || "");
        setTextArea(selectedCampaign.body.introductionMessageBox?.text || "");
        setIntroFontFamily(
          selectedCampaign.body.introductionMessageBox?.fontFamily || ""
        );

        setMessageFontSize(
          selectedCampaign.body.introductionMessageBox?.fontSize || ""
        );
        setMessagefontColorOne(
          selectedCampaign.body.introductionMessageBox?.backgroundColor || ""
        );
        setMessagefontColorTwo(
          selectedCampaign.body.introductionMessageBox?.fontColor || ""
        );
        setQuestionFontSize(selectedCampaign.body.questionBox?.fontSize || "");
        setQuestionfontColorTwo(
          selectedCampaign.body.questionBox?.fontColor || ""
        );
        setQuestionfontColorOne(
          selectedCampaign.body.questionBox?.backgroundColor || ""
        );
        setAnswerFontSize(selectedCampaign.body.answerBox?.fontSize || "");
        setAnswerfontColorTwo(selectedCampaign.body.answerBox?.fontColor || "");
        setAnswerfontColorOne(
          selectedCampaign.body.answerBox?.backgroundColor || ""
        );
        setUrlField(selectedCampaign.body.campaignImageUrl || "");
        setInitialfontColorOne(
          selectedCampaign.body.initialQuestions?.backgroundColor || ""
        );
        setQuestionFontFamily(
          selectedCampaign.body.questionBox?.fontFamily || ""
        );
        setAnswerFontFamily(selectedCampaign.body.answerBox?.fontFamily || "");
        setInitialFontSize(
          selectedCampaign.body.initialQuestions?.fontSize || ""
        );
        setInitialfontColorTwo(
          selectedCampaign.body.initialQuestions?.fontColor || ""
        );
        setInitialQuestionFontFamily(
          selectedCampaign.body.initialQuestions?.fontFamily || ""
        );
        // Check for initialQuestions and questions
        if (
          selectedCampaign.body.initialQuestions &&
          selectedCampaign.body.initialQuestions.questions
        ) {
          setInputTexts(
            selectedCampaign.body.initialQuestions.questions.map(
              (question) => question.question
            )
          );
          // Update answer fields for questions
          const updatedInputTexts = [];
          selectedCampaign.body.initialQuestions.questions.forEach(
            (question) => {
              updatedInputTexts.push(question.question);
              updatedInputTexts.push(question.answer || ""); 
            }
          );
          setInputTexts(updatedInputTexts);
        }
      }

      // Check for footer properties
      if (selectedCampaign.footer) {
        setSendfontColorTwo(selectedCampaign.footer.sendButton?.color || "");
        setsendFontSize(selectedCampaign.footer.sendButton?.fontSize || "");
      }
    }
  }, [selectedCampaign]);

  const handleSubmit = () => {
    const questions = [];
    const answers = [];

    // Separate questions and answers
    inputTexts.forEach((text, index) => {
      if (index % 2 === 0) {
        questions.push(text);
      } else {
        answers.push(text);
      }
    });
    const dashboardData = {
      name: campaignName,
      subDomain: campaignDomain,
      header: {
        height: "",
        backgroundColor: headerBackgroundColor,
        logo: {
          height: "",
          width: "",
          imageUrl: logoImage,
        },
        heading: {
          text: textOne,
          fontSize: fontSizeOne,
          fontColor: fontColorOne,
          fontFamily: headingFontFamily,
        },
        subHeading: {
          text: textTwo,
          fontSize: fontSizeTwo,
          fontColor: fontColorTwo,
          fontFamily: subHeadingFontFamily,
        },
      },
      body: {
        background: {
          type: bodyBackgroundType,
          imageUrl: backgroundImage,
          color: bodyBackgroundColor,
        },
        campaignImageUrl: urlField,
        introductionMessageBox: {
          text: textarea,
          fontSize: messagefontSize,
          fontColor: messagefontColorTwo,
          fontFamily: introFontFamily,
          backgroundColor: messagefontColorOne,
        },
        questionBox: {
          avatar: {
            type: "",
            imageUrl: "",
            color: "",
          },
          backgroundColor: questionfontColorOne,
          fontSize: questionfontSize,
          fontColor: questionfontColorTwo,
          fontFamily: questionFontFamily,
        },
        answerBox: {
          avatar: {
            type: "",
            imageUrl: "",
            color: "",
          },
          backgroundColor: answerfontColorOne,
          fontSize: answerfontSize,
          fontColor: answerfontColorTwo,
          fontFamily: answerFontFamily,
        },
        initialQuestions: {
          backgroundColor: initialfontColorOne,
          fontSize: initialfontSize,
          fontColor: initialfontColorTwo,
          fontFamily: initialQuestionFontFamily,
          questions: questions.map((question, index) => ({
            question,
            answer: answers[index] || "", // Matching answers with questions by index
          })),
        },
      },
      footer: {
        height: 0,
        borderRadius: 0,
        sendButton: {
          color: sendfontColorTwo,
          borderRadius: 0,
          fontSize: sendfontSize,
        },
      },
      status: campaignStatus,
    };
    dispatch(
      addDashboardToCampaign({ campaignId, dashboardData, fetchCampaigns })
    )
      .then(() => {
        dispatch(fetchCampaigns());
        setSubmissionSuccess(true);
        setTimeout(() => {
          onHandleClose();
          toast.success("Attributes added successfully!", {});
        });
      })
      .catch((error) => {
        toast.error("Failed to add Attributes. Please try again later.", {});
      });
  };

  return (
    <div className={`dashboard-form`}>
      <div className="dashboard-header">
        <h2>+ Attributes</h2>
        <div className="close-icon" onClick={onHandleClose}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
      </div>
      <>
        <div className="campaign-details">
          <h3 className="campaign-name">Name: {campaignName}</h3>
          <h3 className="subdomain">Subdomain: {campaignDomain}</h3>
        </div>
        <div className="tab-buttons">
          <button
            className={activeTab === "header" ? "active" : ""}
            onClick={() => handleTabClick("header")}
          >
            Header
          </button>
          <div className="dashed-line"></div>
          <button
            className={activeTab === "body" ? "active" : ""}
            onClick={() => handleTabClick("body")}
          >
            Body
          </button>
          <div className="dashed-line"></div>
          <button
            className={activeTab === "footer" ? "active" : ""}
            onClick={() => handleTabClick("footer")}
          >
            Footer
          </button>
        </div>
        <div className="Scroll-selector">
          {activeTab === "header" && (
            <div className="tab-content">
              {/* Header Content */}
              <h3 className="header-headingtag">Header Content</h3>
              <div className="header-container">
                <div className="content-wrapper">
                  {" "}
                  {/* Wrapper div for flexbox layout */}
                  <div className="background-upload">
                    <label htmlFor="bgUpload">Upload Background Color</label>
                    <SketchPicker
                      color={headerBackgroundColor}
                      onChange={(color) =>
                        handleColorChange(color, "headerBackground")
                      }
                    />
                    {/* <div className="height-input">
                        <label htmlFor="heightInput">
                          Header Height (rem):
                        </label>
                        <input
                          type="number"
                          id="heightInput"
                          value={headerHeight.height}
                          onChange={(e) => handleInputChangee(e, "height")}
                        />
                      </div> */}
                  </div>
                  <div className="logo-dimension-container">
                    <div
                      className="logo-upload"
                      onDrop={handleImageDrop}
                      onDragOver={(e) => e.preventDefault()}
                      onClick={() => inputRef.current.click()}
                    >
                      <h3 className="logo-h3">Upload Logo</h3>
                      {logoImage ? (
                        <div className="logo-preview">
                          <img src={logoImage} alt="Logo" />
                          <div
                            className="close-icon"
                            onClick={handleImageRemove}
                          >
                            <FontAwesomeIcon icon={faTimes} />
                          </div>
                        </div>
                      ) : (
                        <div className="upload-icon">
                          <FontAwesomeIcon icon={faImage} />
                          <p>Drag & Drop or Click to Upload</p>
                        </div>
                      )}
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageSelect}
                        style={{ display: "none" }}
                        ref={inputRef}
                      />
                    </div>
                    {/* <div className="dimension-controls">
                        <h3>Dimensions(PX)</h3>
                        <div>
                          <label>Width:</label>
                          <div className="dimension-control">
                            <input
                              type="number"
                              value={logoDimensions.width}
                              onChange={(e) => handleInputChange(e, "width")}
                            />
                          </div>
                        </div>
                        <div>
                          <label>Height:</label>
                          <div className="dimension-control">
                            <input
                              type="number"
                              value={logoDimensions.height}
                              onChange={(e) => handleInputChange(e, "height")}
                            />
                          </div>
                        </div>
                      </div> */}
                  </div>
                </div>
              </div>
              {/* Additional Container */}
              <div className="row-container">
                <div className="one-container">
                  <h3>Heading</h3>
                  <input
                    type="text"
                    value={textOne}
                    onChange={(e) => setTextOne(e.target.value)}
                    placeholder="Enter text"
                  />
                  <h3>Font Family</h3>

                  <input
                    type="text"
                    value={headingFontFamily}
                    onChange={(e) => setHeadingFontFamily(e.target.value)}
                    placeholder="Enter font family"
                  />
                  <div>
                    <label>Font Size (px):</label>
                    <input
                      type="number"
                      value={fontSizeOne}
                      onChange={(e) => setFontSizeOne(parseInt(e.target.value))}
                    />
                  </div>
                  <div>
                    <label>Font Color:</label>
                    <SketchPicker
                      color={fontColorOne}
                      onChange={(color) =>
                        handleColorChange(color, "fontColorOne")
                      }
                    />
                  </div>
                </div>
                <div className="second-container">
                  <h3>Sub Heading</h3>
                  <input
                    type="text"
                    value={textTwo}
                    onChange={(e) => setTextTwo(e.target.value)}
                    placeholder="Enter text"
                  />
                  <h3>Font Family</h3>

                  <input
                    type="text"
                    value={subHeadingFontFamily}
                    onChange={(e) => setSubHeadingFontFamily(e.target.value)}
                    placeholder="Enter font family"
                  />
                  <div>
                    <label>Font Size (px):</label>
                    <input
                      type="number"
                      value={fontSizeTwo}
                      onChange={(e) => setFontSizeTwo(parseInt(e.target.value))}
                    />
                  </div>
                  <div>
                    <label>Font Color:</label>
                    <SketchPicker
                      color={fontColorTwo}
                      onChange={(color) =>
                        handleColorChange(color, "fontColorTwo")
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeTab === "body" && (
            <div className="tab-content">
              {/* Body Content */}
              <h3 className="header-headingtag">Body Content</h3>
              <div className="body-container">
                <div className="background-settings">
                  <label htmlFor="backgroundType">Background Type:</label>
                  <select
                    id="backgroundType"
                    value={bodyBackgroundType}
                    onChange={handleBackgroundTypeChange}
                  >
                    <option value="color">Color</option>
                    <option value="image">Image</option>
                  </select>
                  {bodyBackgroundType === "color" ? (
                    <SketchPicker
                      color={bodyBackgroundColor}
                      onChange={(color) =>
                        handleColorChange(color, "bodyBackgroundColor")
                      }
                    />
                  ) : (
                    <div
                      className="logo-upload"
                      onDrop={handleBackImageDrop}
                      onDragOver={(e) => e.preventDefault()}
                      onClick={() => inputRef.current.click()}
                    >
                      <h3 className="logo-h3">Upload Image</h3>
                      {backgroundImage ? (
                        <div className="logo-preview">
                          <img src={backgroundImage} alt="Logo" />
                          <div
                            className="close-icon"
                            onClick={handleImageRemove}
                          >
                            <FontAwesomeIcon icon={faTimes} />
                          </div>
                        </div>
                      ) : (
                        <div className="upload-icon">
                          <FontAwesomeIcon icon={faImage} />
                          <p>Drag & Drop or Click to Upload</p>
                        </div>
                      )}
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleBackImageSelect}
                        style={{ display: "none" }}
                        ref={inputRef}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div className="one-container">
                  <h3>Campaign Image URL</h3>
                  <input
                    type="text"
                    value={urlField}
                    onChange={(e) => setUrlField(e.target.value)}
                    placeholder="Enter Url"
                  />
                </div>
                <h3 className="Message-container">Message Conatiner</h3>
                <div className="row-container">
                  <div className="message-one-container">
                    <h3>Message Box</h3>
                    <textarea
                      value={textarea}
                      onChange={(e) => setTextArea(e.target.value)}
                      placeholder="Enter text"
                    ></textarea>
                    <h3>Font Family</h3>

                    <input
                      type="text"
                      value={introFontFamily}
                      onChange={(e) => setIntroFontFamily(e.target.value)}
                      placeholder="Enter font family"
                    />
                  </div>
                  <div className="message-second-container">
                    <div>
                      <label>Background Color:</label>
                      <SketchPicker
                        color={messagefontColorOne}
                        onChange={(color) =>
                          handleColorChange(color, "messageFontColorOne")
                        }
                      />
                    </div>
                    <div>
                      <label>Font Color:</label>
                      <SketchPicker
                        color={messagefontColorTwo}
                        onChange={(color) =>
                          handleColorChange(color, "messageFontColorTwo")
                        }
                      />
                    </div>
                    <div>
                      <label>Font Size (px):</label>
                      <input
                        type="number"
                        value={messagefontSize}
                        onChange={(e) =>
                          setMessageFontSize(parseInt(e.target.value))
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="row-container">
                <div className="message-one-container">
  <h3>Initial Questions & Answers</h3>
  {inputTexts.map((text, index) => (
    <div key={index}>
      <label htmlFor={`question-${index}`}>
        {index % 2 === 0 ? "Q" : "A"}
      </label>
      <textarea
        id={`question-${index}`}
        value={text}
        onChange={(e) => handleInputChanged(e, index)}
        placeholder={index % 2 === 0 ? "Enter question" : "Enter answer"}
      />
      {index === 0 && (
        <>
          <button
            className="decrement-btn"
            onClick={decrementInputCount}
          >
            -
          </button>
          <button
            className="increment-btn"
            onClick={incrementInputCount}
          >
            +
          </button>
        </>
      )}
    </div>
  ))}
</div>
                  <div className="message-second-container">
                    <div>
                      <label>Background Color:</label>
                      <SketchPicker
                        color={initialfontColorOne}
                        onChange={(color) =>
                          handleColorChange(color, "initialFontColorOne")
                        }
                      />
                    </div>
                    <div>
                      <label>Font Color:</label>
                      <SketchPicker
                        color={initialfontColorTwo}
                        onChange={(color) =>
                          handleColorChange(color, "initialFontColorTwo")
                        }
                      />
                    </div>
                    <div>
                      <label>Font Size (px):</label>
                      <input
                        type="number"
                        value={initialfontSize}
                        onChange={(e) =>
                          setInitialFontSize(parseInt(e.target.value))
                        }
                      />
                    </div>
                    <h3>Font Family</h3>

                    <input
                      type="text"
                      value={initialQuestionFontFamily}
                      onChange={(e) =>
                        setInitialQuestionFontFamily(e.target.value)
                      }
                      placeholder="Enter font family"
                    />
                  </div>
                </div>
                <div className="row-container">
                  <div className="one-container">
                    <h2 className="body-headingtag">Question Box</h2>
                    <div>
                      <label>Background Color:</label>
                      <SketchPicker
                        color={questionfontColorOne}
                        onChange={(color) =>
                          handleColorChange(color, "questionFontColorOne")
                        }
                      />
                    </div>
                    <div>
                      <label>Font Color:</label>
                      <SketchPicker
                        color={questionfontColorTwo}
                        onChange={(color) =>
                          handleColorChange(color, "questionFontColorTwo")
                        }
                      />
                    </div>
                    <div>
                      <label>Font Size (px):</label>
                      <input
                        type="number"
                        value={questionfontSize}
                        onChange={(e) =>
                          setQuestionFontSize(parseInt(e.target.value))
                        }
                      />
                    </div>

                    <h3>Font Family</h3>

                    <input
                      type="text"
                      value={questionFontFamily}
                      onChange={(e) => setQuestionFontFamily(e.target.value)}
                      placeholder="Enter font family"
                    />
                  </div>
                  <div className="second-container">
                    <h2 className="body-headingtag">Answer Box</h2>
                    <div>
                      <label>Background Color:</label>
                      <SketchPicker
                        color={answerfontColorOne}
                        onChange={(color) =>
                          handleColorChange(color, "answerFontColorOne")
                        }
                      />
                    </div>
                    <div>
                      <label>Font Color:</label>
                      <SketchPicker
                        color={answerfontColorTwo}
                        onChange={(color) =>
                          handleColorChange(color, "answerFontColorTwo")
                        }
                      />
                    </div>
                    <div>
                      <label>Font Size (px):</label>
                      <input
                        type="number"
                        value={answerfontSize}
                        onChange={(e) =>
                          setAnswerFontSize(parseInt(e.target.value))
                        }
                      />
                    </div>

                    <h3>Font Family</h3>

                    <input
                      type="text"
                      value={answerFontFamily}
                      onChange={(e) => setAnswerFontFamily(e.target.value)}
                      placeholder="Enter font family"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeTab === "footer" && (
            <div className="tab-content">
              <h3 className="header-headingtag">Footer Content</h3>
              <div className="row-container">
                <div className="one-container">
                  <h2 className="body-headingtag">Send Button</h2>
                  <div>
                    <label>Font Color:</label>
                    <SketchPicker
                      color={sendfontColorOne}
                      onChange={(color) =>
                        handleColorChange(color, "sendFontColorOne")
                      }
                    />
                  </div>
                  <div>
                    <label>Background Color:</label>
                    <SketchPicker
                      color={sendfontColorTwo}
                      onChange={(color) =>
                        handleColorChange(color, "sendFontColorTwo")
                      }
                    />
                  </div>
                  <div>
                    <label>Font Size (px):</label>
                    <input
                      type="number"
                      value={sendfontSize}
                      onChange={(e) =>
                        setsendFontSize(parseInt(e.target.value))
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="adb-dashboard-form-actions">
          <button className="button" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </>
    </div>
  );
}

export default AdbotDashboardForm;
